export const defineImgSize = (smMobile: boolean, mobile: boolean) => {
  const sizes = {
    w: '400',
    h: '135',
  };

  if (mobile) {
    sizes.w = '340';
    sizes.h = '114';
  }

  if (smMobile) {
    sizes.w = '288';
    sizes.h = '97';
  }

  return sizes;
};
